// extracted by mini-css-extract-plugin
export default {"main-container":"Invitations_main-container__RaD3L"};